import React from 'react';
import DataTable from '../../components/dataTable';

const DriverTable = (props) => {
  const {
    driverForm,
    removeRegister,
    attributes,
    list,
    loading,
  } = props;

  return (
    <DataTable
      add={driverForm}
      edit={driverForm}
      remove={removeRegister}
      list={list}
      loading={loading}
      attributes={attributes}
      keyField={'id'}
      confirmText={`Você está removendo o motorista <strong><field>name</field></strong>! </br>Realmente deseja fazer isso? `}
      headers={[
        {title: 'sharedName', field: 'name', dataSort: true},
        {title: 'deviceIdentifier', field: 'uniqueId', dataSort: true},
      ]}
    />
  );
};

export default DriverTable;
